import { GzFlexibleTableWebComponent } from './component/GzFlexibleTableWebComponent';
import { WEB_COMPONENT_GZ_FLEXIBLE_TABLE } from '../../webcomponents.constants';

export { GzFlexibleTableWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_FLEXIBLE_TABLE, GzFlexibleTableWebComponent);
